/* eslint react-hooks/exhaustive-deps: "warn" */

import { useRef } from 'react';

import cn from 'classnames';

import { useIntersection } from 'hooks/useIntersection';

import { Icon } from 'ui/atoms/Icon/Icon';
import { Section } from 'ui/molecules/Section/Section';

import styles from './AttributionStage.module.scss';

import type { AttributionStageProps } from './AttributionStage.types';

export const AttributionStage = ({ eyebrow, title, description, data }: AttributionStageProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const play = useIntersection(ref, { threshold: 0.4 });

  const { source, crm } = data;

  return (
    <Section
      align="left"
      title={title}
      description={description}
      extra={eyebrow}
      introBlockClassName={styles.intro}
    >
      <div ref={ref} className={cn(styles.stage, play && styles.play)}>
        <div className={cn(styles.side, styles.source)}>
          <div className={styles.sideHead}>
            <span className={styles.live}>
              <span className={styles.dot} /> {source.label}
            </span>
          </div>

          <div className={styles.sideBody}>
            <div className={styles.reg}>{source.register}</div>

            <a className={styles.file} href={source.filingHref} target="_blank" rel="noopener noreferrer">
              {source.filing}
            </a>

            <div className={styles.meta}>{source.retrieved}</div>
          </div>
        </div>

        <div className={styles.arrow} aria-hidden="true">
          <span className={styles.arrowLine} />
          <span className={styles.packet} />
          <span className={styles.arrowHead}>→</span>
        </div>

        <div className={cn(styles.side, styles.crm)}>
          <div className={styles.sideHead}>
            <span className={styles.dest}>{crm.destination}</span>
          </div>

          <div className={styles.sideBody}>
            <div className={styles.fieldLab}>{crm.fieldLabel}</div>
            <div className={styles.fieldVal}>{crm.fieldValue}</div>

            <div className={styles.verify}>
              <Icon type="check-2" size="small" />
              <span>{crm.verify}</span>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};
